import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AboutPageComponents/DistinctivePracties/page.tsx");
